import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import urls from '@/navigation/urls.ts'
import { Fragment } from 'react'
import { NavLink } from 'react-router-dom'

interface IProps {
  organizations: IEquipment['organizations']
  emptyPlaceholder?: string
  className?: string
}

const EquipmentOrganizationsText = (props: IProps) => {
  const organizations = props.organizations.filter((item) => Boolean(item.organization?.name))

  if (!organizations.length) {
    return <span className={props.className || 'text-nm'}>{props.emptyPlaceholder || '-'}</span>
  }

  return (
    <span className={props.className || 'text-nm'}>
      {organizations.map((organization, index) => (
        <Fragment key={organization.organization.id}>
          {index > 0 ? ', ' : null}
          <NavLink
            to={urls.organizations + '?organizationId=' + organization.organization.id}
            className="text-nm text-link"
            style={{ textDecoration: 'none' }}
          >
            {organization.organization.name}
          </NavLink>
        </Fragment>
      ))}
    </span>
  )
}

export default EquipmentOrganizationsText
